(() => {
  if (window.edmtRaptorPageMounted) return;
  window.edmtRaptorPageMounted = true;
  const seconds = value => `${Math.floor(Math.max(0, value) / 60)}:${String(Math.floor(Math.max(0, value) % 60)).padStart(2, '0')}`;
  function mountBackground(root) {
    const video = root.querySelector('[data-raptor-background-video]');
    if (!video || video.dataset.ready) return;
    video.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let loaded = false;
    const update = () => {
      if (document.hidden || reduced.matches || navigator.connection?.saveData) { video.pause(); return; }
      if (!loaded) {
        video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        video.muted = true;
        video.load();
        loaded = true;
      }
      video.play().catch(() => {});
    };
    document.addEventListener('visibilitychange', update);
    reduced.addEventListener('change', update);
    root.addEventListener('raptor:dispose', () => {
      video.pause();
      document.removeEventListener('visibilitychange', update);
      reduced.removeEventListener('change', update);
    }, { once: true });
    update();
  }
  function mountPage(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const demo = root.querySelector('[data-raptor-demo]');
    const demoButton = root.querySelector('[data-raptor-demo-play]');
    const player = root.querySelector('[data-raptor-player]');
    const audio = player?.querySelector('[data-sample-audio]');
    if (demo && demoButton) {
      demoButton.addEventListener('click', () => demo.play().catch(() => { demoButton.hidden = false; }));
      demo.addEventListener('play', () => { demoButton.hidden = true; audio?.pause(); });
    }
    if (!player || !audio) return;
    const samples = JSON.parse(player.querySelector('[data-raptor-samples]').textContent);
    const title = player.querySelector('[data-sample-title]');
    const time = player.querySelector('[data-sample-time]');
    const play = player.querySelector('[data-sample-play]');
    const icon = player.querySelector('[data-play-icon]');
    const seek = player.querySelector('[data-sample-seek]');
    const clip = player.querySelector('[data-wave-clip]');
    const base = player.querySelector('[data-wave-base]');
    const progress = player.querySelector('[data-wave-progress]');
    const status = player.querySelector('[data-audio-status]');
    const buttons = [...player.querySelectorAll('[data-sample-index]')];
    let current = 0;
    let pendingSeek = null;
    const duration = () => Number.isFinite(audio.duration) ? audio.duration : samples[current].duration;
    function update() {
      const total = duration();
      const position = total > 0 ? Math.min(100, audio.currentTime / total * 100) : 0;
      seek.value = position;
      seek.setAttribute('aria-valuetext', `${seconds(audio.currentTime)} / ${seconds(Math.ceil(total))}`);
      time.textContent = `${seconds(audio.currentTime)} / ${seconds(Math.ceil(total))}`;
      clip.setAttribute('width', String(position * 10.24));
      icon.textContent = audio.paused ? '▶' : 'Ⅱ';
      play.setAttribute('aria-label', `${audio.paused ? player.dataset.playLabel : player.dataset.pauseLabel} ${samples[current].name}`);
    }
    function waveform(peaks) {
      const bars = peaks.map((peak, i) => {
        const h = Math.max(2, Math.min(1, peak) * 108);
        return `<rect x="${i * 1024 / peaks.length}" y="${(120 - h) / 2}" width="${Math.max(1, 1024 / peaks.length - 1.4)}" height="${h}" rx="0.6"></rect>`;
      }).join('');
      base.innerHTML = bars;
      progress.innerHTML = bars;
    }
    function start() {
      demo?.pause();
      status.textContent = '';
      audio.play().catch(error => {
        if (error.name !== 'AbortError') status.textContent = player.dataset.errorLabel;
        update();
      });
    }
    function select(index) {
      if (index === current) { if (audio.paused) start(); else audio.pause(); return; }
      audio.pause();
      current = index;
      pendingSeek = null;
      audio.src = samples[index].url;
      title.textContent = samples[index].name;
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      waveform(samples[index].peaks);
      audio.load();
      update();
      start();
    }
    play.addEventListener('click', () => { if (audio.paused) start(); else audio.pause(); });
    buttons.forEach(button => button.addEventListener('click', () => select(Number(button.dataset.sampleIndex))));
    seek.addEventListener('input', () => {
      const target = Number(seek.value) / 100 * duration();
      if (audio.readyState >= 1) audio.currentTime = target;
      else pendingSeek = target;
      time.textContent = `${seconds(target)} / ${seconds(Math.ceil(duration()))}`;
      clip.setAttribute('width', String(Number(seek.value) * 10.24));
      seek.setAttribute('aria-valuetext', `${seconds(target)} / ${seconds(Math.ceil(duration()))}`);
    });
    audio.addEventListener('loadedmetadata', () => { if (pendingSeek !== null) { audio.currentTime = pendingSeek; pendingSeek = null; } update(); });
    ['timeupdate', 'play', 'pause', 'ended'].forEach(event => audio.addEventListener(event, update));
    audio.addEventListener('error', () => { status.textContent = player.dataset.errorLabel; update(); });
    root.addEventListener('raptor:dispose', () => { audio.pause(); demo?.pause(); }, { once: true });
    update();
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-raptor-background]').forEach(mountBackground);
    scope.querySelectorAll('[data-raptor-arena]').forEach(mountPage);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-raptor-background],[data-raptor-arena]').forEach(root => root.dispatchEvent(new Event('raptor:dispose'))));
})();

